import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import api from './api';
import { useAuth } from './AuthContext';

const fmt = (iso) => { try { return new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }); } catch { return ''; } };

const Messages = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [threads, setThreads] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate('/auth?next=/messages'); return; }
    api.get('/my/threads').then((r) => setThreads(r.data)).finally(() => setReady(true));
  }, [loading, user, navigate]);

  return (
    <div className="bg-[#e9f3ec] py-12 min-h-[70vh]" data-testid="messages-page"><div className="mx-auto max-w-3xl px-5">
      <h1 className="ea-heading text-2xl font-bold">Messages</h1>
      <p className="mt-1 text-sm text-gray-500">Your conversations with {user && user.role === 'client' ? 'selected operatives' : 'clients'}.</p>
      {!ready ? <p className="mt-6 text-gray-500">Loading…</p> : threads.length === 0 ? (
        <p className="mt-6 rounded-2xl bg-white p-8 text-center text-sm text-gray-500 shadow">No conversations yet. A chat opens once an operative is selected for a job.</p>
      ) : (
        <div className="mt-6 space-y-3">
          {threads.map((t) => (
            <Link to={`/jobs/${t.jobId}`} key={t.jobId} data-testid={`thread-${t.jobId}`} className="flex items-center justify-between rounded-2xl bg-white p-5 shadow-sm hover:shadow-md">
              <div className="min-w-0 flex items-start gap-3">
                <div className="mt-0.5 rounded-full bg-[#e9f3ec] p-2 text-[#3a9b5c]"><MessageSquare size={18} /></div>
                <div className="min-w-0">
                  <p className="font-semibold text-[#1b4f72]">{t.otherPartyName || 'Conversation'} <span className="text-xs font-normal text-gray-400">· {t.jobTitle}</span></p>
                  <p className="mt-0.5 truncate text-sm text-gray-500">{t.lastMessage || 'No messages yet'}</p>
                </div>
              </div>
              <div className="ml-3 shrink-0 text-right">
                {t.lastMessageAt && <p className="text-xs text-gray-400">{fmt(t.lastMessageAt)}</p>}
                {t.unread > 0 && <span data-testid={`thread-unread-${t.jobId}`} className="mt-1 inline-block rounded-full bg-[#3a9b5c] px-2 py-0.5 text-xs font-bold text-white">{t.unread}</span>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div></div>
  );
};

export default Messages;
